<template>
	<div id="all">
		<div id="map" ref="map"></div>
		<div id="data">
			<p class="m-0 d-block"><strong>{{datetime}}</strong></p>
			<b-button variant="primary" ref="btn-position" @click="currentPosition"><md-icon icon="gps_fixed" /></b-button>
		</div>
		<b-overlay :show="overlayShow" no-wrap no-center :opacity="1">
			<template #overlay>
				<!-- <p>Buscar ubicacion</p> -->
				<div class="text-center" style="padding: 30% 20px;">
					<!-- <b-button class="btn btn-primary" ref="btn-position" @click="currentPosition"><md-icon icon="gps_fixed" /></b-button> -->
					<div v-if="geolocationStatus == 'denied'">
						<h2>{{$t('driver.noPermission')}}.</h2>
						<b-button href="https://www.loom.com/share/edee95e69fd04b65af71655b06f705bc" target="_blank" size="lg" variant="info">{{$t('driver.howAndroid')}}</b-button>
					</div>
					<div v-if="geolocationStatus == 'prompt'">
						<h2>{{$t('driver.acceptPermission')}}</h2>
					</div>
					<div v-if="geolocationStatus == 'granted'">
						<h2>{{$t('driver.findLocation')}}</h2>
					</div>
					<hr>
					<b-button size="lg" variant="primary" ref="btn-position" @click="currentPosition"><md-icon icon="gps_fixed" /></b-button>
					<h4 class="text-danger"><strong>{{localizationError}}</strong></h4>
				</div>
			</template>
		</b-overlay>
	</div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import BlueMark from "../../../assets/blue-mark.png";

const loader = new Loader({
  apiKey: "AIzaSyDkrd4qa9BH5XW9_79inmSjCVWwYVy1es4",
  version: "weekly",
  libraries: ["places"]
});


export default {
	components: { },
	data() {
		return {
			overlayShow: true,
			map: null,
			infoWindow: null,
			datetime:'',
			marker:null,
			geolocationStatus:'',
			localizationError:'',
		};
	},
	methods: {
		checkPermission(){
			let $this = this;
			navigator.permissions.query({name:'geolocation'}).then(function(result) {
				// Will return ['granted', 'prompt', 'denied']
				$this.geolocationStatus = result.state
			});
		},
		currentPosition(){
			this.datetime = this.$moment().format('D MMM YYYY HH:mm')+' hrs'
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
				position => {
					const pos = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};

					this.marker.setPosition(pos)

					this.map.setCenter(pos);
					this.overlayShow = false
				},
				err => {
					this.localizationError = `Error: ${err.message} Code: ${err.code} `
					this.overlayShow = true
					// console.log(err)
					// this.handleLocationError(true);
				},
				{
					enableHighAccuracy:true,
				}
				);
			} else {
				// Browser doesn't support Geolocation
				this.handleLocationError(false);
			}
		},
		handleLocationError(browserHasGeolocation) {
			this.localizationError = browserHasGeolocation
				? "The Geolocation service failed."
				: "Your browser doesn't support geolocation.";
			this.overlayShow = true
		},
		initMap() {
			loader
				.load()
				.then((google) => {
					this.map = new google.maps.Map(this.$refs["map"], {
						center: { lat: -34.397, lng: 150.644 },
						zoom: 15,
						mapTypeControl: false,
						streetViewControl: false,
						zoomControl: false,
						fullscreenControl: false,
					});
					const image = {
						url:BlueMark,
					}
					this.marker = new window.google.maps.Marker({
						position: { lat: -34.397, lng: 150.644 },
						map: this.map,
						icon: image,
						// label: point,
						// title: ""
					})
					// this.infoWindow = new google.maps.InfoWindow();
					this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.$refs["btn-positon"]);
				})
				.catch(e => {
					console.log(e)
				// do something
				});
		}
	},
	async mounted() {
		this.initMap()
		this.checkPermission()
	},
};
</script>

<style>
	body,html{
		width: 100%;
		height: 100%;
		position: relative;
	}
	#data{
		padding: 10px 20px;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		/*height: 10%;*/
		background-color: white;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	#data p{
		font-size: 18px;
	}
	#map {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}
	#btn-position{
		/*position: absolute;*/
	}
</style>
